import { Component, OnDestroy, OnInit, Input } from '@angular/core';
import { LogCategory, LoggerService, LogType, LogCoreComponent } from '../services/logger.service';
import { SidebarService } from '../services/sidebar.service';
import { ProfileService } from '../services/profile.service';

@Component({
    selector: 'app-side-bar',
    templateUrl: './sidebar.component.html',
    styleUrls: ['./sidebar.component.scss'],
    standalone: false
})
export class SidebarComponent implements OnInit, OnDestroy {

    @Input() content: any;    

    constructor(
        public sidebarService: SidebarService,
        private logger: LoggerService,
        public profileService: ProfileService
    ) {
        this.log("constructor", null, LogCategory.Constructor);        
    }

    private log(method: string = null, message = null, category: LogCategory = LogCategory.Default): void {
        method = (method) ? '.' + method + '()' : '';
        message = (message) ? message.toString() : '';
        this.logger.try(this.constructor.name + method + ': ' + message, LogType.CoreComponent, LogCoreComponent.Sidebar, category);
    }

    ngOnInit(): void {
        this.log("ngOnInit", null, LogCategory.Init);
        if (this.content.title.length <= 0)
            this.content.title = 'Help';
    }

    ngOnDestroy() {
        this.log("ngOnDestroy", null, LogCategory.Destroy);
    }
    
}
